module.exports = __webpack_public_path__ + "img/emoji_61.b1051958.png";